import React from 'react'

/**
 * A line break shown on large screens only, with a space that survives on mobile.
 *
 * Use it between heading fragments that should break on desktop but MUST stay
 * space-separated once the break is hidden on mobile.
 *
 * Writing `<br className="d-none d-lg-block" />` by hand is the trap: on mobile
 * the break is hidden and JSX strips the whitespace between sibling tags, so the
 * words run together ("processingagent", "anddelivers"). This component bakes the
 * `{' '}` in front of the break, so the space can never be forgotten.
 *
 *   <span>…mail processing</span>
 *   <DesktopBreak />
 *   <span>agent…</span>
 *
 * Enforced by tests/no-mobile-br-spacing.test.ts — that guard fails CI on any
 * raw mobile-hidden <br> that drops the space.
 */
export const DesktopBreak: React.FC = () => (
  <>
    {' '}
    <br className='d-none d-lg-block' />
  </>
)
